import styled, { css } from "styled-components";
import { Button } from "@chakra-ui/react";

export const DestructiveButton = styled(Button)`
  ${({ theme }) => css`
  display: flex;
    background: transparent;
    border-radius: 30px;
    border: 2px solid ${theme.colors.error};
    color: ${theme.colors.error};
    padding: 0.8em 1.5em; 
    background: ${theme.colors.error};
    color: ${theme.colors.grey};
  `}
`;